function handleCountryChange(selectEl) {
    var country = selectEl.value.trim();
    var stateSelect = document.getElementById('ContactForm-state');
    var territorySelect = document.querySelector('#ContactForm [name="contact[territory]"]');

    // Auto-set Territory based on country
    if (territorySelect) {
        if (country === 'India') {
            territorySelect.value = 'Domestic (India)';
        } else {
            territorySelect.value = 'Export (International)';
        }
    }

    // Zip / Postal Code: required for India, optional for others
    var zipcodeInput = document.querySelector('#ContactForm input[name="contact[zipcode]"]');
    var zipcodeStar = document.getElementById('zipcode-required-star');
    if (zipcodeInput) {
        if (country === 'India') {
            zipcodeInput.setAttribute('required', '');
            if (zipcodeStar) zipcodeStar.style.display = 'inline';
        } else {
            zipcodeInput.removeAttribute('required');
            if (zipcodeStar) zipcodeStar.style.display = 'none';
        }
    }

    if (!stateSelect) return;

    stateSelect.innerHTML = '<option value="" disabled selected>Loading...</option>';

    fetch('https://countriesnow.space/api/v0.1/countries/states', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country: country })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
        stateSelect.innerHTML = '';
        if (data.error || !data.data || !data.data.states || data.data.states.length === 0) {
            stateSelect.innerHTML = '<option value="" disabled selected>No states found</option>';
            stateSelect.removeAttribute('required');
            return;
        }
        stateSelect.setAttribute('required', '');
        var defaultOpt = document.createElement('option');
        defaultOpt.value = '';
        defaultOpt.disabled = true;
        defaultOpt.selected = true;
        defaultOpt.textContent = 'Select State / Province';
        stateSelect.appendChild(defaultOpt);

        data.data.states.forEach(function(state) {
            var opt = document.createElement('option');
            opt.value = state.name;
            opt.textContent = state.name;
            stateSelect.appendChild(opt);
        });
    })
    .catch(function() {
        stateSelect.innerHTML = '<option value="" disabled selected>Could not load states</option>';
    });
}

function SendContactDetails() {
    var vFirstName = $('#ContactForm input[name="contact[firstname]"]').val();
    var vLastName = $('#ContactForm input[name="contact[lastname]"]').val();
    var vMobileNo = $('#ContactForm input[name="contact[mobileno.]"]').val();
    var vCountry = $('#ContactForm [name="contact[country]"]').val();
    var vCity = $('#ContactForm input[name="contact[city]"]').val();
    var vEmail = $('#ContactForm input[name="contact[email]"]').val();
    var vProfession = $('#ContactForm [name="contact[profession]"]').val();
    var vMessage = $('#ContactForm textarea[name="contact[remarks]"]').val();
    var vTerritory = $('#ContactForm [name="contact[territory]"]').val();
    var vRequirement = $('#ContactForm [name="contact[tentativerequirement]"]').val();
    var vState = $('#ContactForm [name="contact[state]"]').val();
    var vZipcode = $('#ContactForm input[name="contact[zipcode]"]').val();

    var vFullName = (vFirstName || '') + ' ' + (vLastName || '');
    vFullName = vFullName.trim();

    if (vFullName != "" && vMobileNo != undefined && vMobileNo != "") {
        const formData = new FormData();
        formData.append("SourceType", "Website");
        formData.append("SubSourceType", "piccolomosaic.in");
        formData.append("FullName", vFullName);
        formData.append("FirstName", vFirstName || '');
        formData.append("LastName", vLastName || '');
        formData.append("ISDCode", "+91");
        formData.append("MobileNo", vMobileNo);
        formData.append("Country", vCountry || '');
        formData.append("City", vCity || '');
        formData.append("EmailID", vEmail || '');
        formData.append("Profession", vProfession || '');
        formData.append("Message", vMessage || '');
        formData.append("Territory", vTerritory || '');
        formData.append("TentativeRequirement", vRequirement || '');
        formData.append("State", vState || '');
        formData.append("ZipCode", vZipcode || '');

        $.ajax({
            url: API_URL + "leadinquiery",
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response, textStatus, jqXHR) {
                console.log('Response:', response);
                console.log('Status Code:', jqXHR.status);
            },
            error: function (xhr, status, error) {
                console.log('Error:', status, error);
                console.log(xhr.status);
                console.log(error);
                console.log(xhr);
            }
        });
    }
    else {
        return false;
    }
}
